import { postJSON } from 'bv-fetch';

export const enterAccountBreak = () => postJSON('/api/self_exclusion/panic');
